interface FunnelSimpleThinIconProps {
  className?: string;
  color?: string;
}

const FunnelSimpleThinIcon = ({
  className = "w-6 h-6",
  color = "#000000",
}: FunnelSimpleThinIconProps) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.375 12.75C18.375 12.8495 18.3355 12.9448 18.2652 13.0152C18.1948 13.0855 18.0995 13.125 18 13.125H6C5.90054 13.125 5.80516 13.0855 5.73484 13.0152C5.66451 12.9448 5.625 12.8495 5.625 12.75C5.625 12.6505 5.66451 12.5552 5.73484 12.4848C5.80516 12.4145 5.90054 12.375 6 12.375H18C18.0995 12.375 18.1948 12.4145 18.2652 12.4848C18.3355 12.5552 18.375 12.6505 18.375 12.75ZM21.75 7.875H2.25C2.15054 7.875 2.05516 7.91451 1.98484 7.98483C1.91451 8.05516 1.875 8.15054 1.875 8.25C1.875 8.34946 1.91451 8.44484 1.98484 8.51517C2.05516 8.58549 2.15054 8.625 2.25 8.625H21.75C21.8495 8.625 21.9448 8.58549 22.0152 8.51517C22.0855 8.44484 22.125 8.34946 22.125 8.25C22.125 8.15054 22.0855 8.05516 22.0152 7.98483C21.9448 7.91451 21.8495 7.875 21.75 7.875ZM14.25 16.875H9.75C9.65054 16.875 9.55516 16.9145 9.48483 16.9848C9.41451 17.0552 9.375 17.1505 9.375 17.25C9.375 17.3495 9.41451 17.4448 9.48483 17.5152C9.55516 17.5855 9.65054 17.625 9.75 17.625H14.25C14.3495 17.625 14.4448 17.5855 14.5152 17.5152C14.5855 17.4448 14.625 17.3495 14.625 17.25C14.625 17.1505 14.5855 17.0552 14.5152 16.9848C14.4448 16.9145 14.3495 16.875 14.25 16.875Z"
        fill={color}
      />
    </svg>
  );
};

export default FunnelSimpleThinIcon;